const currencies = [
  "Afghani",
  "Ariary",
  "Baht",
  "Balboa",
  "Belarusian ruble",
  "Birr",
  "Bolivar Soberano",
  "Boliviano",
  "Cedi",
  "Colon",
  "Cordoba",
  "Dalasi",
  "Denar",
  "Dinar",
  "Dirham",
  "Dobra",
  "Dollar",
  "Dong",
  "Dram",
  "Escudo",
  "Euro",
  "Florin",
  "Forint",
  "Franc",
  "Gourde",
  "Guarani",
  "Hryvnia",
  "Kina",
  "Kip",
  "Koruna",
  "Krona",
  "Krone",
  "Kwacha",
  "Kwanza",
  "Kyat",
  "Lari",
  "Lek",
  "Lempira",
  "Leone",
  "Leu",
  "Lev",
  "Lilangeni",
  "Lira",
  "Loti",
  "Manat",
  "Marka",
  "Metical",
  "Naira",
  "Nakfa",
  "Ngultrum",
  "None",
  "Ouguiya",
  "Pa'anga",
  "Pataca",
  "Peso",
  "Pound",
  "Pula",
  "Quetzal",
  "Rand",
  "Real",
  "Rial",
  "Riels",
  "Ringgit",
  "Riyal",
  "Ruble",
  "Rufiyaa",
  "Rupee",
  "Rupiah",
  "Shekel",
  "Shilling",
  "Sol",
  "Som",
  "Somoni",
  "Taka",
  "Tala",
  "Tenge",
  "Tugrik",
  "United States Dollar",
  "Vatu",
  "Won",
  "Yen",
  "Yuan Renminbi",
  "Zloty",
];

export const colorsOf100Unit = {
  "AED": "Green",
  "AFN": "Red",
  "ALL": "Blue",
  "AMD": "Brown",
  "ANG": "Red",
  "AOA": "Blue",
  "AQD": "Blue",
  "ARS": "Blue",
  "AUD": "Blue",
  "AWG": "Green",
  "AZN": "Blue",
  "BAM": "Blue",
  "BBD": "Green",
  "BDT": "Red",
  "BGN": "Red",
  "BHD": "Red",
  "BIF": "Blue",
  "BMD": "Green",
  "BND": "Yellow",
  "BOB": "Green",
  "BRL": "Green",
  "BSD": "Green",
  "BTN": "Green",
  "BWP": "Green",
  "BYN": "Blue",
  "BZD": "Green",
  "CAD": "Blue",
  "CDF": "Blue",
  "CHF": "Red",
  "CLP": "Blue",
  "CNY": "Red",
  "COP": "Blue",
  "CRC": "Blue",
  "CUP": "Green",
  "CVE": "Green",
  "CZK": "Blue",
  "DJF": "Blue",
  "DKK": "Red",
  "DOP": "Green",
  "DZD": "Green",
  "EGP": "Green",
  "ERN": "Green",
  "ETB": "Green",
  "EUR": "Blue",
  "FJD": "Red",
  "FKP": "Blue",
  "GBP": "Green",
  "GEL": "Red",
  "GHS": "Red",
  "GIP": "Red",
  "GMD": "Red",
  "GNF": "Green",
  "GTQ": "Green",
  "GYD": "Green",
  "HKD": "Red",
  "HNL": "Red",
  "HTG": "Blue",
  "HUF": "Red",
  "IDR": "Red",
  "ILS": "Red",
  "INR": "Orange",
  "IQD": "Blue",
  "IRR": "Red",
  "ISK": "Red",
  "JEP": "Red",
  "JMD": "Green",
  "JOD": "Red",
  "JPY": "Blue",
  "KES": "Green",
  "KGS": "Red",
  "KHR": "Red",
  "KMF": "Green",
  "KPW": "Blue",
  "KRW": "Green",
  "KWD": "Red",
  "KYD": "Red",
  "KZT": "Blue",
  "LAK": "Green",
  "LBP": "Red",
  "LKR": "Red",
  "LRD": "Green",
  "LSL": "Green",
  "LYD": "Red",
  "MAD": "Red",
  "MDL": "Green",
  "MGA": "Green",
  "MKD": "Red",
  "MMK": "Green",
  "MNT": "Green",
  "MOP": "Green",
  "MRU": "Green",
  "MUR": "Red",
  "MVR": "Red",
  "MWK": "Blue",
  "MXN": "Blue",
  "MYR": "Green",
  "MZN": "Green",
  "NAD": "Green",
  "NGN": "Green",
  "NIO": "Blue",
  "NOK": "Red",
  "NPR": "Red",
  "NZD": "Blue",
  "OMR": "Red",
  "PAB": "Green",
  "PEN": "Red",
  "PGK": "Red",
  "PHP": "Red",
  "PKR": "Green",
  "PLN": "Green",
  "PYG": "Blue",
  "QAR": "Green",
  "RON": "Red",
  "RSD": "Red",
  "RUB": "Red",
  "RWF": "Green",
  "SAR": "Green",
  "SBD": "Green",
  "SCR": "Green",
  "SDG": "Green",
  "SEK": "Red",
  "SGD": "Red",
  "SHP": "Blue",
  "SLL": "Green",
  "SOS": "Green",
  "SRD": "Green",
  "SSP": "Blue",
  "STN": "Green",
  "SYP": "Green",
  "SZL": "Green",
  "THB": "Green",
  "TJS": "Green",
  "TMT": "Green",
  "TND": "Green",
  "TOP": "Green",
  "TRY": "Green",
  "TTD": "Green",
  "TWD": "Green",
  "TZS": "Green",
  "UAH": "Blue",
  "UGX": "Green",
  "USD": "Green",
  "UYU": "Green",
  "UZS": "Green",
  "VES": "Green",
  "VND": "Red",
  "VUV": "Green",
  "WST": "Red",
  "XAF": "Blue",
  "XCD": "Green",
  "XOF": "Blue",
  "XPF": "Blue",
  "YER": "Green",
  "ZAR": "Green",
  "ZMW": "Green",
  "ZWL": "Blue"
}

export default currencies;
